import { combineReducers } from "redux";
import user from "./user";
import driver from "./driver";
import translation from "./translation";
import gameplay from "./gameplay";
import fixture from "./fixture";
import constraints from "./constraints";
import country from "./country";
import circuit from "./circuit";
import league from "./league";
import leaderboard from "./leaderboard";
import statistics from "./statistics";
import mixapi from "./mixapi";
import footerPartners from "./footerPartners";
import geolocation from "./geolocation";
import menu from "./menu";
import announcements from "./announcements";
import eos from "./eos";
import webconfig from "./webconfig";
import homepage from "./homepage";
import seasonPerformance from "./seasonPerformance";
import completeYourProfile from "./complete-your-profile";
import cloudinary from "./cloudinary";
import commonConfig from "./commonConfig";
import fixtureCircuitConfig from "./fixtureCircuitConfig";

export default combineReducers({
  user,
  driver,
  translation,
  gameplay,
  fixture,
  constraints,
  country,
  circuit,
  league,
  leaderboard,
  statistics,
  mixapi,
  footerPartners,
  geolocation,
  menu,
  announcements,
  eos,
  webconfig,
  homepage,
  seasonPerformance,
  completeYourProfile,
  cloudinary,
  commonConfig,
  fixtureCircuitConfig,
});
